function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var module;
// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/

var is_node = typeof module == 'object' && module.exports;
if (is_node) ;else ;
define(['react', 'classnames', '/www/hola/pub/util.js', '/www/hola/pub/settings_ctx.tsx', '/www/shared/hooks/use_viewport_margin.tsx', '/www/hola/pub/lib/tooltip.module.less'], (React, cn, www_util, {
  Settings_context
}, {
  use_viewport_margin
}, styles) => {
  var useState = React.useState,
    useEffect = React.useEffect,
    useMemo = React.useMemo,
    useRef = React.useRef,
    useContext = React.useContext;
  styles = styles.default;
  var Tooltip = ({
    cls,
    cls_cn,
    content,
    children,
    click_mode,
    hover_mode,
    ref_origin,
    only_external_close,
    close_btn,
    prop_ref,
    fixed_on_mobile,
    block,
    fast,
    viewport_margin
  }) => {
    var root_ref = useRef();
    var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      clicked = _useState2[0],
      set_clicked = _useState2[1];
    var _use_viewport_margin = use_viewport_margin(viewport_margin, [clicked]),
      content_ref = _use_viewport_margin.ref;
    var tooltip_cls = cn(styles.hola_tooltip, cls, fixed_on_mobile && styles.show_fixed_on_mobile, clicked && styles['hola_tooltip--clicked']);
    var timeouts = useMemo(() => ({}), []);
    var _useContext = useContext(Settings_context),
      popups = _useContext.popups;
    var set_clicked_perr = value => {
      set_clicked(old => {
        if (old !== value && ref_origin) {
          if (value) www_util.perr({
            id: `${ref_origin}_popup_open`
          });else www_util.perr({
            id: `${ref_origin}_popup_close`
          });
        }
        return value;
      });
    };
    if (prop_ref) prop_ref.close = () => {
      set_clicked_perr(false);
    };
    useEffect(() => {
      var close = () => {
        if (click_mode && root_ref) {
          var parent = document.activeElement;
          while (parent) {
            if (parent == root_ref.current) return;
            parent = parent.parentElement;
          }
        }
        set_clicked_perr(false);
      };
      popups === null || popups === void 0 ? void 0 : popups.push(close);
      document.addEventListener('click', close);
      return () => {
        document.removeEventListener('click', close);
        var i = popups === null || popups === void 0 ? void 0 : popups.indexOf(close);
        popups === null || popups === void 0 ? void 0 : popups.splice(i, 1);
      };
    }, []);
    var Root_tag = block ? 'div' : 'span';
    return /*#__PURE__*/React.createElement(Root_tag, {
      className: tooltip_cls,
      ref: root_ref,
      onClick: ev => {
        ev.stopPropagation();
        ev.nativeEvent.stopImmediatePropagation();
        if (!click_mode) return;
        if (!only_external_close || !clicked) set_clicked_perr(!clicked);
      },
      onMouseOver: () => {
        if (hover_mode) {
          setTimeout(() => {
            set_clicked_perr(true);
            clearTimeout(timeouts.m_leave);
          }, 0);
        }
      },
      onMouseOut: () => {
        if (hover_mode) {
          clearTimeout(timeouts.m_leave);
          timeouts.m_leave = setTimeout(() => {
            set_clicked_perr(false);
          }, fast ? 0 : 500);
        }
      },
      onMouseDown: ev => ev.stopPropagation()
    }, children, content && /*#__PURE__*/React.createElement("div", {
      ref: content_ref,
      className: cn(cls_cn, styles.hola_tooltip_content, (click_mode || hover_mode) && styles['hola_tooltip_content--click'], !fast && styles.with_animation),
      onClick: ev => {
        if (click_mode) {
          ev.stopPropagation();
          ev.nativeEvent.stopImmediatePropagation();
        }
      }
    }, close_btn && /*#__PURE__*/React.createElement("div", {
      className: styles.close,
      onClick: () => {
        set_clicked_perr(false);
      }
    }, "x"), content));
  };
  return {
    Tooltip
  };
});